import { FilesPickerInput } from "../../../../Files/shared/FilesPickerInput.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { useFormikContext } from "formik";
//#region src/modules/Records/shared/RecordForm/components/FilesTab.tsx
function FilesTab() {
	const { setFieldValue, values } = useFormikContext();
	return /* @__PURE__ */ jsx(FilesPickerInput, {
		onChangeValue: (newFileUrls) => setFieldValue("fileUrls", newFileUrls),
		onSetPrimaryImage: (url) => setFieldValue("primaryImageUrl", url),
		previouslyUploadedFileUrls: values.fileUrls,
		primaryImageUrl: values.primaryImageUrl
	});
}
//#endregion
export { FilesTab };

//# sourceMappingURL=FilesTab.js.map